import React, { PureComponent } from 'react';

import './slidebar.scss';

import { SlidebarAPI } from '@philips-emr/tws-components-api';
import { KeyCode, Theme } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, bool, element, eventListener, oneOf, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, enumValues } from '@philips-emr/tws-utils';

import { ModalClose, ModalTitle } from '../modal/components';

function isFunction(cb) {
  return typeof cb === 'function';
}

const acceptedTypes = enumValues(ComponentType);

@AwesomeComponent({ type: ComponentType.LAYOUT, api: SlidebarAPI })
class Slidebar extends PureComponent {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    uuid: string,
    className: string,
    closeByDocument: bool,
    closeByEscape: bool,
    onBeforeClose: eventListener,
    onClose: eventListener,
    open: bool,
    theme: oneOf(enumValues(Theme)),
    title: string,
  };

  static defaultProps = {
    closeByDocument: true,
    closeByEscape: true,
  };

  componentDidMount() {
    this.modalRef && this.modalRef.focus();
  }

  getModalClass = () => {
    const { className, open } = this.props;

    const modalClasses = {
      'c-modal': true,
      'c-modal--slidebar': true,
      [className]: className,
      'is-open': open,
    };

    return classNames(modalClasses);
  };

  shouldClose = () => {
    if (!this.state.open) {
      return;
    }
    let close = true;

    const abortFn = () => close = false;
    const { onBeforeClose } = this.props;

    onBeforeClose({ abort: abortFn });

    return close;
  };

  closeModal = () => {
    const shouldClose = this.shouldClose();

    if (!shouldClose) {
      return;
    }

    const { onClose } = this.props;

    if (isFunction(onClose)) {
      onClose();
    }
  };

  closeByDocument = (event) => {
    const { classList } = event.target;
    const { closeByDocument } = this.props;

    if (!closeByDocument) return;
    if (!classList.contains('c-modal')) return;

    this.closeModal();
  };

  closeByEscape = (event) => {
    const { closeByEscape } = this.props;

    if (!closeByEscape || event.keyCode !== KeyCode.ESC) return;

    this.closeModal();
  };

  render() {
    const { children, title, theme, uuid } = this.props;

    const Container = ContainerProvider.provide(this);

    return (
      <div
        className={this.getModalClass()}
        onClick={this.closeByDocument}
        onKeyDownCapture={this.closeByEscape}
        tabIndex="0"
        ref={(modalRef) => {
          this.modalRef = modalRef;
        }}
      >
        <div className="c-modal__wrapper">
          <ModalClose theme={theme} onClick={this.closeModal} />
          <ModalTitle>{title}</ModalTitle>

          <Container acceptedTypes={acceptedTypes} uuid={uuid} className="c-modal__content">{children}</Container>
        </div>
      </div>
    );
  }
}

export default Slidebar;
